import { render, staticRenderFns } from "./DocPartyTable.vue?vue&type=template&id=227aa9a6"
import script from "./DocPartyTable.vue?vue&type=script&lang=js"
export * from "./DocPartyTable.vue?vue&type=script&lang=js"
import style0 from "./DocPartyTable.vue?vue&type=style&index=0&id=227aa9a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports